import React, { useState } from 'react';
// @ts-ignore
import styles from './UserWalletBalance.module.scss';
import UserWalletDepositModal from '../UserWalletDeposit/UserWalletDepositModal';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	title: string;
	balance: number;
	isPurchasable?: boolean;
}

const UserWalletBalance: React.FC<Props> = ({ title, balance, isPurchasable = false }) => {
	const [isPurchaseOpen, setIsPurchaseOpen] = useState(false);
	const { t } = useTranslation();
	return (
		<div className={styles.wrapper}>
			<div className={styles.leftPart}>
				<img src='/dist/patientV3/icons/coins-solid.svg' alt='coins' />
				<div className={styles.balanceWrapper}>
					<div>{title}</div>
					<div className={styles.balance}>{balance}</div>
				</div>
			</div>
			{isPurchasable && (
				<>
					<div className={styles.buy} onClick={() => setIsPurchaseOpen(true)}>{t('component.userWalletWrapper.buy')}</div>
					{isPurchaseOpen && <UserWalletDepositModal isOpen onClose={() => setIsPurchaseOpen(false)}/>}
				</>
			)}
		</div>
	);
};

export default UserWalletBalance;

